<template>  
    <section class="block block--about">
        <div
            v-if="block.image"
            class="about__img"
            :style="{ backgroundImage: `url('${$VUE_APP_API_URL + block.image.url}')` }"
            :alt="block.image.caption">
        </div>
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 about__content">
                    <h2 v-if="block.title">{{ block.title }}</h2>
                    <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
                    <div v-if="block.description" v-html="block.description"></div>
                    <div class="mt-1">
                        <router-link to="/about" class="btn btn-primary">Learn More</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: 'about',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>